import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';

import {
  RequisitionFormDeleteParam,
  RequisitionsFormFetchResponse,
  RequisitionsFormUpdateBody,
} from './form.types';

@Injectable({ providedIn: 'root' })
export class RequisitionsFormHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetch(): Observable<RequisitionsFormFetchResponse> {
    return this.httpApi.get('/requisitions/settings/form');
  }

  public update(body: RequisitionsFormUpdateBody): Observable<RequisitionsFormFetchResponse> {
    return this.httpApi.patch('/requisitions/settings/form', {}, body);
  }

  public delete(param: RequisitionFormDeleteParam): Observable<RequisitionsFormFetchResponse> {
    return this.httpApi.delete(`/requisitions/settings/form/${param}`);
  }
}
